enum ReportDownloadType {
  Technology = 'TECHNOLOGY',
  Projects = 'PROJECTS',
  ConcreteUser = 'CONCRETE_USER',
  Users = 'USERS',
  Contract = 'CONTRACT',
  Unknown = 'UNKNOWN',
}

export default ReportDownloadType
